// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".team-price[data-v-62a0325a]{text-align:right}.team-count[data-v-62a0325a]{font-size:14px;color:#666;margin-top:10px}.total-cost[data-v-62a0325a]{font-weight:700;font-size:18px;margin:15px 0}.money[data-v-62a0325a]{color:#28a745}", ""]);
// Exports
module.exports = exports;
